import Vue from "vue";
import VueRouter from "vue-router";
import Credentials from "./Credentials/index";
import ItStockAdjustmentRouter from "./modules/IT/index";
import MasterDataRouter from "./modules/MasterData/index";
import SalesItemRouter from "@/router/modules/Sales/Items/index";
import Reports from "./modules/Reports/index";
import SalesReports from "./modules/Reports/SalesReports/index";
import AcctItemCosting from "@/router/modules/Accounting/ItemCosting/index";
import AcctStatementOfAccount from "@/router/modules/Accounting/StatementOfAccount/index";
import AcctCreditMemo from "@/router/modules/Accounting/CreditMemo/index";
import AcctDebitMemo from "@/router/modules/Accounting/DebitMemo/index";
import AcctPayments from "@/router/modules/Accounting/Payments/index";
import AccountingReports from "./modules/Reports/AccountingReports/index";
import SystemSettings from "./Main/SystemSettings/SystemSettings";
import repository from "@/api/credentials";
import salesquotationnew from "@/router/modules/Sales/SalesQuotation/index";
import SalesOrderGroupComponent from "@/router/modules/Sales/SalesOrdersNew/index";
import PackingListRouter from "@/router/modules/Sales/PackingList/index";
import PromosRouter from "@/router/modules/Sales/Promos/index";
import ChangePassword from "@/router/Utils/index";
import AccountingBanks from "@/router/modules/Accounting/Banks/index";
import PackingListHistory from "@/router/modules/Accounting/PackingListHistory/index";

import store from "@/store";
import DebitMemoHistory from "@/router/modules/Accounting/DebitMemoHistory/index";
import HRLeaveApplication from "@/router/modules/HR/LeaveApplication/index";

Vue.use(VueRouter);
const routes = [
  ...Credentials,
  {
    path: "/home",
    name: "home",
    title: "Home",
    component: () => import("@/views/main/HomeView.vue"),
    beforeEnter: (to, from, next) => {
      repository
        .authentication()
        .then(() => {
          store.dispatch("credentials");
          store.dispatch("GeneralSettings");
          store.dispatch("renderSideNav");
          if (window.location.search) {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search.slice(1));
            params.delete("username");
            params.delete("password");
            window.history.replaceState({}, "", `${window.location.pathname}${window.location.hash}`);
          }
          next();
        })
        .catch(() => {
          localStorage.setItem("last_visit", to.fullPath);
          localStorage.removeItem("token");
          if (localStorage.getItem("userLogged") || localStorage.getItem("token2")) {
            let payload = JSON.parse(localStorage.getItem("userLogged"));
            store.dispatch("login", payload).then((success) => {
              localStorage.setItem("token", success.access_token);
              store.dispatch("renderSideNav");
              next({ name: "home" });
              if (localStorage.getItem("token")) {
                localStorage.removeItem("userLogged");
                localStorage.removeItem("token2");
              }
            });
          } else if (window.location.search) {
            const utils = new shared();
            utils.userLogged(next);
          } else {
            if (process.env.NODE_ENV == "production") {
              location.href = "https://m4d8q2.com";
            } else {
              return next({ name: "login" });
            }
          }
        });
    },
    children: [
      ...MasterDataRouter,
      ...ItStockAdjustmentRouter,
      ...SalesItemRouter,
      ...Reports,
      ...SalesReports,
      ...AcctItemCosting,
      ...AcctStatementOfAccount,
      ...AcctCreditMemo,
      ...AcctDebitMemo,
      ...AcctPayments,
      ...AccountingReports,
      ...SystemSettings,
      ...salesquotationnew,
      ...SalesOrderGroupComponent,
      ...PackingListRouter,
      ...PromosRouter,
      ...ChangePassword,
      ...AccountingBanks,
      ...PackingListHistory,
      ...DebitMemoHistory,
      ...HRLeaveApplication,
      {
        path: "/no-access",
        component: () => import("@/views/main/no-access.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: "Home",
    },
  },
];
const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem("token")) {
    next();
  } else if (!to.meta.requiresAuth && localStorage.getItem("token")) {
    next("/home");
  } else {
    if (typeof to.meta.title !== "undefined") {
      document.title = `${process.env.VUE_APP_TITLE} - ${to.meta.title}`;
    } else {
      document.title = `${process.env.VUE_APP_TITLE}`;
    }
    next();
  }
});

export default router;
